import { Clickable } from '@carvana/merch-components';
import classNames from 'classnames';
import { useContext } from 'react';
import ModalContext from '~/context/srp/ModalContext/ModalContext';
import FilterIcon from '~/icons/srp/FilterIcon';
import { IconWithTextWrapper } from '../SearchHeader/SearchHeader.styles';
import useGetFilterTags from '../useGetFilterTags';

export default function MobileFilters({ isStickySearchBar }) {
  const filterTags = useGetFilterTags();
  const { setFilterModalOpen } = useContext(ModalContext);

  const numberOfTags = filterTags.length;

  return (
    <>
      <Clickable
        className={classNames(
          'flex h-full items-center pl-16 self-center l:hidden',
          {
            'text-white l:hidden': isStickySearchBar
          }
        )}
        data-analytics-id="Filter Menu"
        data-analytics-attributes={JSON.stringify({
          item: 'open modal button'
        })}
        data-qa="open-filter-modal"
        onClick={() => setFilterModalOpen(true)}
      >
        <IconWithTextWrapper className="h-full tl-header-xs m:tl-header-s">
          <FilterIcon stroke={isStickySearchBar ? 'white' : undefined} />
          <span className="m-0">Filter</span>
        </IconWithTextWrapper>
        {numberOfTags > 0 && (
          <div
            className={classNames(
              'flex h-[16px] items-center justify-center ml-4 rounded-full tl-label-xs w-[16px]',
              {
                'bg-white text-blue-6': isStickySearchBar,
                'bg-blue-4 text-white': !isStickySearchBar
              }
            )}
          >
            {numberOfTags}
          </div>
        )}
      </Clickable>
    </>
  );
}
